import React, { useState } from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";
import ScrollTrigger from "react-scroll-trigger";

const Skills = () => {
  const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="skills" id="skills">
        <h1 className="mainHeading">Skills</h1>
        <p className="mainPara">My Technical Skills</p>
        <div className="skillsContent">
          <ScrollTrigger
            onEnter={() => setAnimationOn(true)}
            onExit={() => setAnimationOn(false)}
          >
            {animationOn && (
              <div className="skill animate__animated animate__fadeInLeft">
                <h3>Frontend</h3>
                <div className="skillCon">
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> HTML{" "}
                    </p>
                    <p className="qual">Advanced</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> CSS{" "}
                    </p>
                    <p className="qual">Advanced</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> JavaScript{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> React{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Next{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Tailwind{" "}
                    </p>
                    <p className="qual">Basic</p>
                  </div>
                </div>
              </div>
            )}
          </ScrollTrigger>

          <ScrollTrigger
            onEnter={() => setAnimationOn(true)}
            onExit={() => setAnimationOn(false)}
          >
            {animationOn && (
              <div className="skill animate__animated animate__fadeInUp">
                <h3>Backend</h3>
                <div className="skillCon">
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Node{" "}
                    </p>
                    <p className="qual">Basic</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Express{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> PHP{" "}
                    </p>
                    <p className="qual">Basic</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Laravel{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Mongo DB{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> My SQL{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                </div>
              </div>
            )}
          </ScrollTrigger>

          <ScrollTrigger
            onEnter={() => setAnimationOn(true)}
            onExit={() => setAnimationOn(false)}
          >
            {animationOn && (
              <div className="skill animate__animated animate__fadeInRight">
                <h3>Graphics & Others</h3>
                <div className="skillCon">
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> CorelDraw{" "}
                    </p>
                    <p className="qual">Advanced</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> AI{" "}
                    </p>
                    <p className="qual">Basic</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Photoshop{" "}
                    </p>
                    <p className="qual">Basic</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> Marketing{" "}
                    </p>
                    <p className="qual">Basics</p>
                  </div>
                  <div className="skillLang">
                    <p className="lang">
                      <BsFillPatchCheckFill classname="langIcon" /> UI / UX{" "}
                    </p>
                    <p className="qual">Intermediate</p>
                  </div>
                  {/* <div className="skillLang">
                <p className="lang">
                  <BsFillPatchCheckFill classname="langIcon" /> My SQL{" "}
                </p>
                <p className="qual">Intermediate</p>
              </div> */}
                </div>
              </div>
            )}
          </ScrollTrigger>
        </div>
      </div>
    </>
  );
};

export default Skills;
